/**
 * Anchor links result in HTTP 404 errors as the URL they point to does not exist.
 * This function removes them from the markdown.
 */
export const removeAnchorLinks = (markdown: string) => {
    const ancorLinksRegex = /\[.*?\]\(#.*?\)/g;
    return markdown.replace(ancorLinksRegex, "");
};
